module.exports = __webpack_public_path__ + "static/media/EA.31404c01.svg";